export default __webpack_public_path__ + "static/media/Vipin Sir.f1b85151.jfif";